(() => {
  const initShopLook = (sectionRoot) => {
    if (!sectionRoot) return;

    const imageContainer = sectionRoot.querySelector('.image_container');
    if (!imageContainer || imageContainer.dataset.shopLookInitialized === 'true') return;

    const items = imageContainer.querySelectorAll('.shop_the_look_item');
    if (!items.length) return;

    imageContainer.dataset.shopLookInitialized = 'true';

    let activeItem = null;

    const clearActive = () => {
      if (!activeItem) return;
      activeItem.classList.remove('is-active');
      activeItem = null;
    };

    const positionCard = (item) => {
      const card = item.querySelector('.shop_the_look_card');
      if (!card) return;

      card.style.setProperty('--card-shift-x', '0px');
      card.style.setProperty('--card-shift-y', '0px');

      requestAnimationFrame(() => {
        const containerRect = imageContainer.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const padding = 8;
        let shiftX = 0;
        let shiftY = 0;

        if (cardRect.left < containerRect.left + padding) {
          shiftX = containerRect.left + padding - cardRect.left;
        } else if (cardRect.right > containerRect.right - padding) {
          shiftX = containerRect.right - padding - cardRect.right;
        }

        if (cardRect.bottom > containerRect.bottom - padding) {
          shiftY = containerRect.bottom - padding - cardRect.bottom;
        }

        if (cardRect.top + shiftY < containerRect.top + padding) {
          shiftY = containerRect.top + padding - cardRect.top;
        }

        card.style.setProperty('--card-shift-x', `${shiftX}px`);
        card.style.setProperty('--card-shift-y', `${shiftY}px`);
      });
    };

    const setActive = (item) => {
      if (activeItem === item) return;
      if (activeItem) activeItem.classList.remove('is-active');
      activeItem = item;
      if (!activeItem) return;
      activeItem.classList.add('is-active');
      positionCard(activeItem);
    };

    items.forEach((item) => {
      const dot = item.querySelector('.shop_the_look_dot');
      if (!dot) return;

      dot.addEventListener('mouseenter', () => {
        setActive(item);
      });
      dot.addEventListener('focus', () => {
        setActive(item);
      });
      dot.addEventListener('click', () => {
        setActive(item);
      });
    });

    imageContainer.addEventListener('mouseleave', () => {
      clearActive();
    });

    window.addEventListener('resize', () => {
      if (activeItem) positionCard(activeItem);
    });
  };

  const initAll = () => {
    document.querySelectorAll('.image_with_collection_tpg').forEach((sectionRoot) => {
      initShopLook(sectionRoot);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.detail || !event.detail.sectionId) return;
    const sectionRoot = document.querySelector(
      `.image_with_collection_tpg[data-section-id="${event.detail.sectionId}"]`
    );
    initShopLook(sectionRoot);
  });
})();
